var React = require('react');

function TwitterX (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.521 3.32251H20.4652L14.0331 10.6739L21.5999 20.6775H15.6752L11.0347 14.6104L5.72495 20.6775H2.77904L9.65875 12.8144L2.3999 3.32251H8.47505L12.6696 8.86811L17.521 3.32251ZM16.4877 18.9153H18.1191L7.58861 4.99215H5.83798L16.4877 18.9153Z","fill":"#1C232B"}));
}

TwitterX.displayName = "TwitterX";

TwitterX.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = TwitterX;

TwitterX.default = TwitterX;
